<template>
  <div class="mt-8">
    <div>
      <div class="w-full">
        <img src="/img/icons/check-azul.svg" class="mx-auto my-2" />
        <h1 class="text-center text-5xl font-black">{{$t('shared.purchase_confirmation')}}</h1>
        <p class="text-center text-xl font-black">
          {{$t('shared.weve_sent_you_an_email')}}
        </p>
      </div>
      <app-box-booking class="card">
        <p class="text-xl font-black">{{$t('shared.purchase_summary')}}</p>
        <div v-for="extra in bonus.extras" :key="extra.id">
          <div class="flex justify-between py-2">
            <span>{{ extra.extra.title }} x {{extra.quantity}}</span>
            <span>{{ extra.price | currency }}</span>
          </div>
          <hr />
        </div>
        <div v-for="bag in bonus.bags" :key="bag.id">
          <div class="flex justify-between py-2">
            <span>{{ bag.name }} ({{ bag.description }})</span>
            <span>{{ bag.price | currency }}</span>
          </div>
          <hr />
        </div>
        <div class="flex justify-between total-import">
          <span class="text-xl font-black">{{$t('shared.total_amount')}}: </span>
          <span class="text-xl font-black total-price">{{
            bonus.total_price | currency
          }}</span>
        </div>
      </app-box-booking>
    </div>
    <app-box-booking v-if="redsysParams" class="card">
      <redsys-data-component
        :redsysData="redsysParams"
      ></redsys-data-component>
    </app-box-booking>
    <div class="mx-auto w-40 text-center">
      <v-btn
        rounded
        color="secondary"
        class="avm-btn mx-auto lg:ml-0"
        width="auto"
        min-width="auto"
        @click="navigateToURL"
      >
        {{$t('shared.reserve_area')}}
      </v-btn>
    </div>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import { SET_RESERVATION_CODE_ACTION } from "../../store/reserve-area/action-types";

export default {
  data: () => {
    return {
      bonus: {},
    };
  },
  props: {
    bonusCode: {
      type: String,
      required: true,
    },
  },
  computed: {
    redsysParams() {
      return (
        (this.$route.query.redsys && JSON.parse(this.$route.query.redsys)) ||
        null
      );
    },
  },
  methods: {
    ...mapActions({
      setReservationCode: SET_RESERVATION_CODE_ACTION,
    }),
    navigateToURL(item) {
      window.location.replace(
        `/area-reserva/${this.bonus.reservation.code}/resumen`
      );
    },
  },
  created() {
    axios
      .get(`/api/bonus/${this.bonusCode}`)
      .then(({ data }) => {
        this.bonus = data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 31.5rem;
  @media (max-width: 678px) {
    width: 100%;
  }
  margin: 1.25rem auto;

  .component-container {
    border: none !important;
    padding: 0;
  }
}

.total-import {
  margin-top: 0.6rem;
}

.total-price {
  color: #00adbc;
}
</style>